module.exports = __webpack_public_path__ + "img/1@2x.76c9d040.png";